import Avatar from '@/components/linear/avatar';
import EmptyState from '@/components/linear/empty-state';
import PageToolbar from '@/components/linear/page-toolbar';
import StatusIcon from '@/components/linear/status-icon';
import { openIssuePath } from '@/lib/linear-paths';
import { formatCompactTime } from '@/lib/time';
import type { Issue } from '@/types/issue';
import { Link } from '@inertiajs/react';

interface Props {
  issues?: Issue[];
}

export default function Index({ issues = [] }: Props) {
  return (
    <div className="ln-page">
      <PageToolbar title="Pulse" showNew={false} />
      <div className="ln-page-scroll">
        {issues.length === 0 ? (
          <EmptyState title="You’re all caught up" description="Workspace updates will show here." />
        ) : (
          issues.map((issue) => (
            <Link key={issue.id} href={openIssuePath(issue)} className="ln-row" style={{ height: 48 }}>
              <StatusIcon status={issue.status} />
              <span className="ln-row-id">{issue.identifier}</span>
              <span className="ln-row-title">{issue.title}</span>
              <span className="ln-row-meta">
                <span className="ln-row-date">{formatCompactTime(issue.updatedAt || issue.createdAt)}</span>
                {issue.assignee ? (
                  <Avatar name={issue.assignee.name} color={issue.assignee.avatarColor} size={18} />
                ) : null}
              </span>
            </Link>
          ))
        )}
      </div>
    </div>
  );
}
